import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ValidatorFn } from '@angular/forms';
import { endDateNotBeforeStart } from '../../../../../utils/date-range.validator';
import { markAllAsTouched } from '../../../../../utils/markAllAsTouched';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-edit-education-modal',
  standalone: true,
  imports: [MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule, ReactiveFormsModule, CommonModule, MatIconModule, TranslateModule],
  templateUrl: './edit-education-modal.component.html',
  styleUrl: '../edit-modal.scss'
})
export class EditEducationModalComponent {

  educationForm: FormGroup;
  loading: boolean = false;

  // Custom validator to check if the date is valid
  dateValidator: ValidatorFn = (control: AbstractControl): { [key: string]: boolean } | null => {
    const dateValue = control.value;
    const year = new Date(dateValue).getFullYear();
    return isNaN(year) || year.toString().length !== 4 ? { invalidDate: true } : null;
  };

  constructor(
    public dialogRef: MatDialogRef<EditEducationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder 
  ) {
    
    this.educationForm = this.fb.group({
      degree: [this.data.education.title || '', Validators.required],
      institution: [this.data.education.institution || '', Validators.required],
      startDate: [this.data.education.start_date || '', [Validators.required, this.dateValidator]],
      endDate: [this.data.education.end_date || '', [ this.dateValidator]]
    }, { validators: endDateNotBeforeStart });

  }

  close(): void {
    this.dialogRef.close();
  }

  saveEditEducation() {
    if (this.educationForm.valid) {
        const editedEducation = {
            title: this.educationForm.get('degree')?.value,
            institution: this.educationForm.get('institution')?.value,
            start_date: this.educationForm.get('startDate')?.value,
            end_date: this.educationForm.get('endDate')?.value
        };
        this.dialogRef.close(editedEducation);
    } else {
        markAllAsTouched(this.educationForm); // Mark all fields as touched to show validation errors
    }
  }
}
